import React, { useState } from "react";
import { PaginationControl } from "react-bootstrap-pagination-control";
import axios from "axios";
import SideBar from "../../SideBar";
import { useEffect } from "react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useLocation, Link } from "react-router-dom";
import { Input, Pagination } from "@nextui-org/react";

import Swal from "sweetalert2";

import {
  FaCashRegister,
  FaInfoCircle,
  FaPray,
  FaFileMedical,
  FaPenSquare,
  FaPaperPlane,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";

const StockTran = () => {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = "http://192.168.1.15:4000/api/";
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };
  const [stockTranLists, setStockTranLists] = useState([]);
  const [tranCount, setTranCount] = useState("");

  const [excelList, setExcelList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [val, setVal] = useState('');

  const [branchesLists, setBranchesLists] = useState([]);
  const [branchFilterLists, setBranchFilterLists] = useState([]);
  const [showBranchFilter, setShowBranchFilter] = useState(false);
  const [showOrigin, setShowOrigin] = useState(true);
  const [showSearchDate, setShowSearchDate] = useState(false);
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [searchByDateList, setSearchByDateList] = useState([]);
  const [medTotalPrice, setMedTotalPrice] = useState("");
  const [proMedTotalPrice, setProMedTotalPrice] = useState("");
  const [proAccTotalPrice, setProAccTotalPrice] = useState("");
  const [allTotalPrice, setAllTotalPrice] = useState("");
  const [show, setShow] = useState(false);
  const [dataCount, setDataCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState("");

  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const paginationItems = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return stockTranLists.slice(start, end);
  }, [page, stockTranLists]);


  const handleChoose = (event) => {
    // console.log(event, "branch");
    if (event === "all") {
      window.location.reload();
    } else {
      const res = stockTranLists.filter((el) => el.relatedBranch._id == event)
      setStockTranLists(
        res
      );
      setDataCount(
        res.length
      );
      setPages(
        res.length %
          rowsPerPage ===
          0
          ? res.length /
          rowsPerPage
          : Math.floor(
            res.length /
            rowsPerPage
          ) + 1
      );
      setShowOrigin(false);
      setShowSearch(false);
      setShowBranchFilter(true);
      setShowSearchDate(false);
    }
  };

  const handleFilterDate = async () => {
    setShow(true)
    const nDate = new Date(to);
    const finalDate = nDate.setDate(nDate.getDate() + 1);
    const data = {
      startDate: from,
      endDate: to
    }
    const res = stockTranLists.filter(
      (el) =>
        new Date(el.date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }) >=
        new Date(from).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }) &&
        new Date(el.date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }) <=
        new Date(to).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
    )
    setStockTranLists(
      res
    );
    setDataCount(
      res.length
    );
    setPages(
      res.length %
        rowsPerPage ===
        0
        ? res.length /
        rowsPerPage
        : Math.floor(
          res.length /
          rowsPerPage
        ) + 1
    );

    await api
      .get(`stock-transfers/excel`, { params: data })
      .then(res => {


        setExcelList(res.data.stockTransferData)
        // console.log(res.data.stockTransferData

        //   , ' excel')


        setShow(false)



      })
      .catch(error => {

        console.log('error', error)
      })
    // setShowSearchDate(false);
    // setShowSearchDate(true);
    // setShowBranchFilter(false);

    // setShowOrigin(true);
  };

  const handleDelete = (event) => {
    api
      .delete("stock-transfer/" + event)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Successfully Deleted!",
          icon: "success",
          confirmButtonText: "OK",
        });
        const result = stockTranLists.filter((item) => item._id !== event);
        setStockTranLists(result);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const search = async (val) => {
    console.log(val === '', 'val')
    setVal(val)

    if (val) {

      const res = stockTranLists.filter(
        (el) =>
          el.requestedBy.toLowerCase().includes(val.toLowerCase()) ||
          el.requestNo.toLowerCase().includes(val.toLowerCase())
      )
      setStockTranLists(
        res
      );
      setDataCount(
        res.length
      );
      setPages(
        res.length %
          rowsPerPage ===
          0
          ? res.length /
          rowsPerPage
          : Math.floor(
            res.length /
            rowsPerPage
          ) + 1
      );

    } else if (val === '') {

      const res = await api.get(
        "stock-transfers"
        //'http://localhost:9000/api/treatments'
      );
      setStockTranLists(res.data.list);
      setDataCount(
        res.data.list.length
      );
      setPages(
        res.data.list.length %
          rowsPerPage ===
          0
          ? res.data.list.length /
          rowsPerPage
          : Math.floor(
            res.data.list.length /
            rowsPerPage
          ) + 1
      )

    }

    // setShowSearch(true);
    // setShowBranchFilter(false);
    // setShowSearchDate(false);

    // setShowOrigin(true);

  };

  const TwoTotal = [...medTotalPrice, ...proMedTotalPrice, ...proAccTotalPrice];
  // console.log(TwoTotal[0], "two");

  //   const AllTotal = TwoTotal.reduce((acc, curr) => acc+curr
  //  , 0)
  //   console.log(TwoTotal.reduce((acc, curr) => acc+curr
  //  , 0), 'all')
  //   setAllTotalPrice(TwoTotal.reduce((acc, curr) => acc+curr
  //  , 0))

  useEffect(() => {
    const getStockTranLists = async () => {
      try {
        const res = await api.get(
          "stock-transfers"
          //'http://localhost:9000/api/treatments'
        );
        setStockTranLists(res.data.list);
        setDataCount(
          res.data.list.length
        );
        setPages(
          res.data.list.length %
            rowsPerPage ===
            0
            ? res.data.list.length /
            rowsPerPage
            : Math.floor(
              res.data.list.length /
              rowsPerPage
            ) + 1
        );
        // console.log(res.data.list.generalItems, 'rrrr')
        //Med Total
        const MedTotal = res.data.list.map((i) =>
          i.medicineLists.reduce((acc, curr) => acc + curr.totalPrice, 0)
        );

        setMedTotalPrice(MedTotal);

        //Pro Med Total
        const ProMedTotal = res.data.list.map((i) =>
          i.procedureMedicine.reduce((acc, curr) => acc + curr.totalPrice, 0)
        );

        setProMedTotalPrice(ProMedTotal);

        // console.log(ProMedTotal, "pro total");

        //Pro Acc Total
        const ProAccTotal = res.data.list.map((i) =>
          i.procedureAccessory.reduce((acc, curr) => acc + curr.totalPrice, 0)
        );

        setProAccTotalPrice(ProAccTotal);

        // console.log(ProAccTotal, "pro acc total");

        setTranCount(res.data.list.length);

        // console.log(res.data.list, "tran");
      } catch (err) {
        console.log(err.message);
      }
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchesLists(res.data.list);
      } catch (err) {
        console.log(err.message);
      }
    };

    getBranches();

    getStockTranLists();
  }, []);
  const _export = React.useRef(null);

  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data, "excel");

      _export.current.props.data.map(function (element, index) {
        element.date = element.date?.split("T")[0];
        element.code = element.code;
        element.typeName = element.item.item_id?.medicineItemName ? 'Medicine Item' : element.item.item_id?.procedureItemName ? 'Procedure Medicine Item' : element.item.item_id?.accessoryItemName ? 'Accessories Items' : element.item.item_id?.generalItemName && 'General Items'
        element.name = element.item.item_id?.medicineItemName || element.item.item_id?.procedureItemName || element.item.item_id?.accessoryItemName || element.item.item_id?.generalItemName
      });

      _export.current.save();
    }
  };
  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active'>
                      Stock Transfer List &nbsp;
                      <b className='bg-red rounded-5 px-2 py-2'>{tranCount}+</b>
                    </li>{" "}
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-6'>
                  <div className='row'>
                    <div className='form-group col-md-3'>
                      <label>From</label>
                      <input
                        type='date'
                        name='from'
                        id='from'
                        onChange={(e) => setFrom(e.target.value)}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group col-md-3'>
                      <label>To</label>
                      <input
                        type='date'
                        name='to'
                        id='to'
                        onChange={(e) => setTo(e.target.value)}
                        className='form-control'
                      />
                    </div>
                    <div className='form-group col-md-2'>
                      <button
                        className='btn btn-sm btn-primary'
                        style={{ marginTop: "40px" }}
                        onClick={handleFilterDate}
                      >
                        Search
                      </button>
                    </div>
                    <div className='col-4' style={{ marginTop: "2.6em" }}>
                      <div className='form-group'>
                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => handleChoose(e.target.value)}
                        >
                          <option hidden>Filter By Branches</option>
                          <option value='all'>ALL</option>
                          {branchesLists.map((option, i) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-12 px-2'>
                      <span className='text-red'>*</span>&nbsp;<span className='text-md text-decoration-underline font-monospace py-2'>Please Date Filter For Item Export</span>&nbsp;<span className='text-red'>*</span>
                    </div>

                  </div>
                </div>
                <div className='offset-2 col-4' style={{ marginTop: "2.3em" }}>
                  <div className='row'>
                    <div className='col-6'>
                      <Input
                        type='search'
                        className='form-control rounded ml-1'
                        style={{ borderRadius: "12px" }}
                        id='search_code'
                        labelPlaceholder='Search'
                        onChange={(e) => search(e.target.value)}
                      />
                    </div>
                    <div className='col-3'>

                      <button
                        type='button'
                        disabled={!excelList[0]}
                        className='btn btn-sm btn-success'
                        onClick={excelExport}
                      >
                        {show ? 'Loading' : 'Export'}
                      </button>


                    </div>
                  </div>
                </div>
              </div>
              <div className='row mt-3'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-body'>
                      <div className='row'>
                        <div className='col-md-12'>
                          <div
                            className='card-body' style={scroll}

                          >
                            <ExcelExport data={excelList} ref={_export} fileName="Stock-Transfer-List.xlsx">
                              <ExcelExportColumn
                                field=''
                                title='No'
                                locked={true}
                                width={30}
                              />
                              <ExcelExportColumn
                                field='date
'
                                title='Date'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={200}
                              />
                              <ExcelExportColumn
                                field='requestNo
'
                                title='Transfer No'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='requestedBy
'
                                title='Issued By'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='transferBy
'
                                title='Request By'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='totalPrice
'
                                title='Total Price'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='relatedBranch.name
'
                                title=' Branch'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='typeName
'
                                title='Item Type'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='item.item_id.code
'
                                title='Item Code'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={250}
                              />
                              <ExcelExportColumn
                                field='name
'
                                title='Item Name'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={450}
                              />


                              <ExcelExportColumn
                                field='item.stockQty'
                                title='Stock Qty'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={150}
                              />
                              <ExcelExportColumn
                                field='item.requestedQty'
                                title='Requested Qty'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={350}
                              />

                              <ExcelExportColumn
                                field='item.transferQty'
                                title='Transfer Qty'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={150}
                              />
                              <ExcelExportColumn
                                field='item.totalPrice
'
                                title='Item Total Amount'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={150}
                              />
                              <ExcelExportColumn
                                field='item.item_id.unit'
                                title='Unit'
                                headerCellOptions={{
                                  textAlign: 'center'
                                }}
                                cellOptions={{
                                  textAlign: 'center'
                                }}
                                width={150}
                              />

                            </ExcelExport>
                            <table id='example1' className='table'>
                              <thead className='sticky-top bg-light'>
                                <tr>
                                  <th>#</th>
                                  <th>Date</th>
                                  <th>Transfer No</th>
                                  <th>Issued By</th>
                                  <th>Total Amount</th>
                                  <th>Branch</th>

                                  {/* <th>Check</th> */}
                                  <th className='text-center'>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paginationItems[0] ? paginationItems
                                  .slice(0)
                                  .reverse()
                                  .map((st, i) => (
                                    <tr>
                                      <td>{(page - 1) * rowsPerPage + i + 1}</td>
                                      <td>
                                        {st.date ? st.date.split("T")[0] : ""}
                                      </td>
                                      <td>{st.requestNo}</td>
                                      <td>{st.requestedBy}</td>
                                      <td>{st.totalPrice}</td>

                                      <td>{st.relatedBranch.name}</td>

                                      <td className='text-center'>
                                        {/* <div>
                                        <UnitUpdate2 TreatId={TreatId} />
                                      </div> */}
                                        <Link
                                          to={"/st-update/" + st._id}
                                          className='btn btn-sm btn-light'
                                        >
                                          <FaInfoCircle />
                                        </Link>
                                        &nbsp;
                                        {/* <button
                                            className='btn btn-sm btn-danger'
                                            onClick={e => handleDelete(st._id)}
                                          >
                                            <FaRegTrashAlt />
                                          </button> */}
                                      </td>
                                    </tr>
                                  )) : (
                                  <div>

                                    <span className='text-lg text-center mt-5 fs-4'>Loading ...</span>
                                  </div>)}
                              </tbody>
                            </table>


                          </div>

                          <div className='mt-4'>
                            <PaginationControl
                              page={page}
                              between={4}
                              total={dataCount}
                              limit={100}
                              changePage={(page) => {
                                setPage(page);
                              }}
                              ellipsis={1}
                            />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <Treatement
                open={open}
                close={() => setOpen(false)}
                setTreatmentLists={setTreatmentLists}
                treatmentLists={treatmentLists}
              /> */}
            </div>
          </section>
          {/* For Stock Transfer List All and Date Filter List */}

          {/* End        */}
        </div>
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className='main-footer' style={{ marginTop: "50px;" }}>
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside className='control-sidebar control-sidebar-dark'>
        {/* <!-- Control sidebar content goes here --> */}
      </aside>

      {/* <!-- ./wrapper --> */}
    </div>
  );
};

export default StockTran;
